// extracted by mini-css-extract-plugin
export default {"terms-of-use":"terms-of-use_terms-of-use__1Wgdz","terms-page-wrapper":"terms-of-use_terms-page-wrapper__cWxXc"};